import { companyTypes } from '../actions/company_action';
import { initalizerTypes } from '../actions/initializer_actions';
const companyReducerDefaultState = {
  companyName: '',
  companyAbout: '',
  companyVideo: 'https://www.youtube.com/watch?v=a1Y73sPHKxw',
  established: '',
  proportion: '',
  avAge: '',
  employeeCount: '',
  companyLogo: '',
  companyEmail: '',
  companyWebsite: '',
  colaborators: [
    { link: '', name: '', title: '', commentary: '' },
    { link: '', name: '', title: '', commentary: '' },
    { link: '', name: '', title: '', commentary: '' },
  ],
  companyCulture: [{ title: '', cultureLongform: '', img: '' }],
  locationName: '',
  latlang: [],
};

export default (state = companyReducerDefaultState, action) => {
  switch (action.type) {
    case initalizerTypes.FETCH_COMPANY_DATA:
      return {
        ...action.data,
      };
    case companyTypes.PUBLISH_DATA:
      return {
        ...state,
        ...action.data,
      };
    case companyTypes.GET_USERS:
      return {
        ...state,
        users: [...action.users],
      };
    case companyTypes.NEW_USER:
      return {
        ...state,
        users: [...state.users, action.user],
      };
    case companyTypes.EDIT_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case companyTypes.GETEMAIL:
      return {
        ...state,
        EmailTemplate: action.payload,
      };
    default:
      return state;
  }
};
